import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/Seo";

// NOTE: items in [BRACKETS] are placeholders the owner must complete before launch.

const SECTIONS = [
  {
    h: "What this website is",
    p: [
      "theaidoctor.website is the public website of The AI Doctor, operated by Nicolas Moreau, trading as The AI Doctor, 64 Lotissement Les Bastides, 83340 Les Mayons (Var), France. Company registration (SIREN/SIRET): [TO ADD BEFORE LAUNCH]. Contact: info@theaidoctor.website.",
      "The site presents an AI Business Check-Up and related services, publishes articles, and links to a separate Check-Up portal and scheduling tools.",
    ],
  },
  {
    h: "Using the site",
    p: [
      "You may browse and share public content freely. You may not scrape the site at scale, attempt to disrupt it, or misuse the embedded services. Nothing on this site creates a client relationship.",
    ],
  },
  {
    h: "Informational content — not advice",
    p: [
      "Articles, examples and figures on this site are general information and illustrations, not professional, legal, financial or technical advice for your specific situation. Sample results shown anywhere on the site are illustrative estimates, not guarantees.",
      "Recommendations for your business come only from your actual Check-Up. These website terms do not replace — and are not — a client service agreement: any paid treatment is governed by its own signed agreement, scope and price.",
    ],
  },
  {
    h: "Intellectual property",
    p: [
      "The site, its text, design and imagery are the property of Nicolas Moreau / The AI Doctor. You may quote short excerpts with a link back; you may not republish whole pages or pass the content off as your own.",
    ],
  },
  {
    h: "Third-party services and links",
    p: [
      "The site embeds or links to third-party services — the Check-Up portal (Lovable), scheduling (Zoho), payments (Stripe), and social platforms (Instagram, WhatsApp, X, LinkedIn). Their own terms and privacy policies apply when you use them. I'm not responsible for third-party sites I don't control.",
    ],
  },
  {
    h: "Liability",
    p: [
      "The site is provided \"as is\". To the extent permitted by law, I'm not liable for indirect losses arising from using or being unable to use this website. Nothing here limits liability that cannot be limited by law.",
    ],
  },
  {
    h: "Governing law & contact",
    p: [
      "These terms are governed by French law, and any dispute falls under the French courts of the Var jurisdiction, without prejudice to mandatory consumer-protection rules.",
      "Questions about these terms: info@theaidoctor.website. Effective date: July 2026.",
    ],
  },
];

export default function Terms() {
  return (
    <div data-testid="terms-page">
      <Seo
        title="Terms of Use | The AI Doctor"
        description="Terms of use for theaidoctor.website: what the site is, intellectual property, informational content, third-party services and contact."
      />
      <PageHero
        eyebrow="Terms of Use"
        title="The house rules. Short and readable."
        intro="What this website is, what you can do with it, and where its limits are."
      />
      <section className="shell pb-28 lg:pb-40 max-w-3xl">
        <div className="border-t border-white/10">
          {SECTIONS.map((s, i) => (
            <Reveal key={s.h} delay={i * 0.04} className="py-10 border-b border-white/10">
              <h2 className="display text-2xl text-[#f5f3ee]">{s.h}</h2>
              {s.p.map((para, j) => (
                <p key={j} className="mt-4 text-[#a7a7a2] text-lg leading-relaxed">{para}</p>
              ))}
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
